import AppApi from "./Api";
import axiosInstance from "./AxiosInstance";

export const AdminDashboardApi = AppApi.injectEndpoints({
    endpoints: (builder) => ({
        getAdminRowOne: builder.query({
            queryFn: async ({startDate, endDate, customers}) => {
                try {
                    const formData = new FormData();
                    formData.append('startDate', startDate);
                    formData.append('endDate', endDate);
                    formData.append('customer', customers);
                    const response = await axiosInstance.post("/dashboard/user_tile_one", formData);
                    return { data: response.data };
                } catch (error) {
                    return { error: (error as any).response?.data || "Something went wrong" };
                }
            },
            providesTags: ["AdminDashboard"],
        }),
        getAdminOTLDistribution: builder.query({
            queryFn: async ({startDate, endDate, customers}) => {
                try {
                    const formData = new FormData();
                    formData.append('startDate', startDate);
                    formData.append('endDate', endDate);
                    formData.append('customer', customers);
                    const response = await axiosInstance.post("/dashboard/admin_ot_late", formData);
                    return { data: response.data };
                } catch (error) {
                    return { error: (error as any).response?.data || "Something went wrong" };
                }
            },
            providesTags: ["AdminDashboard"],
        }),
        getAdminDeliveryByRegin: builder.query({
            queryFn: async ({startDate, endDate, customers}) => {
                try {
                    const formData = new FormData();
                    formData.append('startDate', startDate);
                    formData.append('endDate', endDate);
                    formData.append('customer', customers);
                    const response = await axiosInstance.post("/dashboard/admin_delivery_region", formData);
                    return { data: response.data };
                } catch (error) {
                    return { error: (error as any).response?.data || "Something went wrong" };
                }
            },
            providesTags: ["AdminDashboard"],
        }),
        getAdminVegicleGPS: builder.query({
            queryFn: async ({startDate, endDate, customers}) => {
                try {
                    const formData = new FormData();
                    formData.append('startDate', startDate);
                    formData.append('endDate', endDate);
                    formData.append('customer', customers);
                    const response = await axiosInstance.post("/dashboard/vehicle_gps_availability", formData);
                    return { data: response.data };
                } catch (error) {
                    return { error: (error as any).response?.data || "Something went wrong" };
                }
            },
            providesTags: ["AdminDashboard"],
        }),
        getNetProfit: builder.query({
            queryFn: async ({startDate, endDate, customers}) => {
                try {
                    const formData = new FormData();
                    formData.append('startDate', startDate);
                    formData.append('endDate', endDate);
                    formData.append('customer', customers);
                    const response = await axiosInstance.post("/dashboard/net_profit", formData);
                    return { data: response.data };
                } catch (error) {
                    return { error: (error as any).response?.data || "Something went wrong" };
                }
            },
            providesTags: ["AdminDashboard"],
        }),
        getCustomerWiseShipment: builder.query({
            queryFn: async ({startDate, endDate}) => {
                try {
                    const formData = new FormData();
                    formData.append('startDate', startDate);
                    formData.append('endDate', endDate);
                    const response = await axiosInstance.post("/dashboard/user_customer_wise_shipment", formData);
                    return { data: response.data };
                } catch (error) {
                    return { error: (error as any).response?.data || "Something went wrong" };
                }
            },
            providesTags: ["AdminDashboard"],
        }),
    }),
});

export const { 
    useGetAdminRowOneQuery,
    useGetAdminOTLDistributionQuery,
    useGetAdminDeliveryByReginQuery,
    useGetAdminVegicleGPSQuery,
    useGetNetProfitQuery,
    useGetCustomerWiseShipmentQuery
} = AdminDashboardApi;